<script setup lang="ts">
import { computed, type CSSProperties } from 'vue';
import {
  createBackgroundStyle,
  createTextStyle,
  createBorderStyle,
  combineStyles,
} from '@/common/customisation/utils/styleUtils';
import { useCsatSuggestionOptionsCustomisation } from '../composables/useCsatUserSuggestionsCustomisation';

export interface ImprovementCategoryProps {
  label: string;
  isSelected?: boolean;
}

const props = defineProps<ImprovementCategoryProps>();

const emit = defineEmits<{
  (event: 'click'): void;
}>();

// Call composable directly in component - no need to pass as props
const { backgroundColor, textColor, borderColor, selectedBackgroundColor, selectedBorderColor, selectedTextColor } =
  useCsatSuggestionOptionsCustomisation();

const computedStyle = computed<CSSProperties>(() => {
  if (props.isSelected) {
    return combineStyles(
      createBackgroundStyle(selectedBackgroundColor),
      createTextStyle(selectedTextColor),
      createBorderStyle(selectedBorderColor)
    );
  }

  return combineStyles(
    createBackgroundStyle(backgroundColor),
    createTextStyle(textColor),
    createBorderStyle(borderColor)
  );
});

const handleClick = () => {
  emit('click');
};
</script>

<template>
  <button
    :class="['improvement-category', 'theme-font-main', 'btn-radius']"
    :aria-label="label"
    :style="computedStyle"
    tabindex="0"
    @click="handleClick"
  >
    {{ label }}
  </button>
</template>

<style scoped lang="scss">
.improvement-category {
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  border-style: solid;
  border-width: 1px;

  &:hover {
    opacity: 0.8;
  }

  &--selected {
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
